// app/features/auth/authStore.ts
//
// Zustand store mirroring the ChatStore + ThemeStore pattern from earlier
// phases. AuthProvider populates this on mount via /api/v1/auth/me.

import { create } from "zustand";

export interface AuthUser {
  email: string;
  isAdmin: boolean;
  isUploader: boolean;
  // Visibility-tier fields populated from GET /api/v1/me (Phase 2).
  isWcs: boolean;
  customerId: string | null;
  uploaderCustomerId: string | null;
}

interface AuthState {
  user: AuthUser | null;
  isLoading: boolean;
  setUser: (user: AuthUser | null) => void;
  setLoading: (loading: boolean) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isLoading: true,
  setUser: (user) => set({ user, isLoading: false }),
  setLoading: (isLoading) => set({ isLoading }),
  clear: () => set({ user: null, isLoading: false }),
}));
